export default __webpack_public_path__ + "static/media/KumoSpace.9bd99247.png";